export default __webpack_public_path__ + "static/media/ghost-logo.285ec245.svg";